import { ObservableArray, View } from "binder"
import { ImportProductViewModel } from "./importProduct-viewModel"
import { PurchaseProcessViewModel } from "./purchaseProcess/purchaseProcess-viewModel";
import { IImportingPart } from "./ipart";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ImportProductView extends View<ImportProductViewModel>{
    GetViewUniqueId(): string {
        return "V-9CD0FF02-51B7-41A5-BAC8-DE17F842D989"
    }
    loadHtml(): string {
        let element = require('./importProduct.html').default;
        let style = require('./importProduct.less');
        return element;
    }
    constructor() {
       super();
    }

    public set purchaseProcessSelector(v: PurchaseProcessViewModel) { this._purchaseProcessSelector = v; } public get purchaseProcessSelector(): PurchaseProcessViewModel { return this._purchaseProcessSelector;} private _purchaseProcessSelector: PurchaseProcessViewModel;

    public set parts(v: ObservableArray<IImportingPart>) { this._parts = v; } public get parts(): ObservableArray<IImportingPart> { return this._parts;} private _parts: ObservableArray<IImportingPart>;
    public set selectedPart(v: IImportingPart) { this._selectedPart = v; } public get selectedPart(): IImportingPart { return this._selectedPart;} private _selectedPart: IImportingPart;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set saleTo(v: moment.Moment) { this._saleTo = v; } public get saleTo(): moment.Moment { return this._saleTo;} private _saleTo: moment.Moment;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
    analyze(){
        this.dataContext.analyze();
    }
}
